import type { StepState } from './state';
import { HOSTED_ONLY_STEPS, type OnboardingStep, STEP_ORDER } from './step';

/** The next step in the flow, skipping the Hosted-only steps on the embedded path. */
export const getNextStep = (current: OnboardingStep, state?: StepState): OnboardingStep | null => {
  let idx = STEP_ORDER.indexOf(current);
  if (idx === -1 || idx === STEP_ORDER.length - 1) {
    return null;
  }
  let next: OnboardingStep = STEP_ORDER[idx + 1];
  while (state?.recommendedVariant === 'embedded' && HOSTED_ONLY_STEPS.has(next)) {
    idx++;
    /* v8 ignore next 3 -- defensive: the hosted-only steps never sit at the end of STEP_ORDER, so this guard can't trip with the current order */
    if (idx >= STEP_ORDER.length - 1) {
      return null;
    }
    next = STEP_ORDER[idx + 1];
  }
  return next;
};
